import classNames from 'classnames';
import { ReactNode } from 'react';
import { Heading } from 'yoso';
import styles from '~/components/Error/Message/Empty/EmptyErrorMessage.module.scss';
import textBalloon from '~/components/Icon/textBalloon.png';

export type EmptyErrorMessageProps = {
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
  size?: 'medium' | 'large'; // large for whole page empty
};
export const EmptyErrorMessage = ({
  className,
  title,
  size = 'medium',
  description,
}: EmptyErrorMessageProps) => (
  <div className={classNames(styles.root, styles[size], className)}>
    <img className={styles.image} src={textBalloon} alt="empty" width={82} height={82} />
    {title && (
      <Heading level={4} className={styles.title}>
        {title}
      </Heading>
    )}
    {description && <p className={styles.description}>{description}</p>}
  </div>
);
